import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SmallRectangleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M15.6 8.4H8.40002V15.6H15.6V8.4Z" fill={color} />
    </BaseIcon>
  ),
);

SmallRectangleIcon.displayName = 'SmallRectangleIcon';
